import { apiRequest } from '../config/api';

export interface Aviso {
  id: string;
  titulo: string;
  mensagem: string;
  lado: 'esquerdo' | 'direito';
  data: string;
  status: 'ativo' | 'inativo';
  filial?: string;
  criado_em: string;
  atualizado_em: string;
}

export const AvisosService = {
  async buscarTodas(filial?: string): Promise<Aviso[]> {
    try {
      const params = filial ? `?filial=${filial}` : '';
      const response = await apiRequest(`/avisos${params}`, {
        method: 'GET'
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar avisos:', error);
      return [];
    }
  },

  async buscarPorId(id: string): Promise<Aviso | null> {
    try {
      const response = await apiRequest(`/avisos/${id}`, {
        method: 'GET'
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar aviso:', error);
      return null;
    }
  },

  async criar(aviso: Omit<Aviso, 'id' | 'criado_em' | 'atualizado_em'>): Promise<Aviso | null> {
    try {
      const response = await apiRequest('/avisos', {
        method: 'POST',
        body: JSON.stringify(aviso)
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao criar aviso:', error);
      return null;
    }
  },

  async atualizar(id: string, aviso: Partial<Omit<Aviso, 'id' | 'criado_em' | 'atualizado_em'>>): Promise<Aviso | null> {
    try {
      const response = await apiRequest(`/avisos/${id}`, {
        method: 'PUT',
        body: JSON.stringify(aviso)
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar aviso:', error);
      return null;
    }
  },

  async deletar(id: string): Promise<boolean> {
    try {
      await apiRequest(`/avisos/${id}`, {
        method: 'DELETE'
      });
      return true;
    } catch (error) {
      console.error('Erro ao deletar aviso:', error);
      return false;
    }
  }
};
